import type { Member } from './schemas';
import type { JobListItem } from '@/features/jobs/schemas';

export type MemberWorkingStatus = 'working' | 'idle' | 'blocked';

export function memberStatus(member: Pick<Member, 'id'>, jobs: JobListItem[]): MemberWorkingStatus {
  const mine = jobs.filter((j) => j.assigned_member.id === member.id);
  // Acknowledged failures are "handled" — only unacknowledged ones block.
  if (mine.some((j) => j.status === 'failed' && !j.acknowledged_at)) return 'blocked';
  if (mine.some((j) => j.status === 'running')) return 'working';
  return 'idle';
}

export function currentJobTitleFor(
  member: Pick<Member, 'id'>,
  jobs: JobListItem[],
): string | undefined {
  const running = jobs
    .filter((j) => j.assigned_member.id === member.id && j.status === 'running')
    .sort((a, b) => {
      const av = a.started_at ? Date.parse(a.started_at) : 0;
      const bv = b.started_at ? Date.parse(b.started_at) : 0;
      return bv - av;
    });
  return running[0]?.title;
}

export function currentJobStartedAtFor(
  member: Pick<Member, 'id'>,
  jobs: JobListItem[],
): string | undefined {
  const running = jobs
    .filter((j) => j.assigned_member.id === member.id && j.status === 'running')
    .sort((a, b) => {
      const av = a.started_at ? Date.parse(a.started_at) : 0;
      const bv = b.started_at ? Date.parse(b.started_at) : 0;
      return bv - av;
    });
  return running[0]?.started_at ?? undefined;
}
